// ──────────────────────────────────────────────────────────
// pages/StrategyDashboardPage.jsx
//
// Uses: hooks/useStrategyDashboard.js (SSE version)
//       components/TradeCard.jsx
//       components/SignalRow.jsx
//
// Add to App.jsx:
//   import StrategyDashboardPage from "./pages/StrategyDashboardPage";
//   <Route path="/strategy" element={<StrategyDashboardPage />} />
// ──────────────────────────────────────────────────────────

import { useState } from "react";
import { useStrategy } from "../../hooks/useStrategy";
import TradeCard from "../TradeCard/TradeCard";
import SignalRow from "../SignalRow/SignalRow";
import "./StrategyDashboard.css";

// export default function StrategyDashboard() {
//   const {
//     openTrades,
//     closedTrades,
//     signals,
//     summary,
//     settings,
//     loading,
//     error,
//     toggleAutoTrade,
//     closeTrade,
//     closeAll,
//   } = useStrategy();

//   const [tab, setTab] = useState("live");
//   const [closingAll, setClosingAll] = useState(false);

//   if (loading) return <Loader />;
//   if (error) return <ErrorState message={error} />;

//   const autoOn = settings.auto_trade_enabled;

//   const handleCloseAll = async () => {
//     setClosingAll(true);
//     await closeAll();
//     setClosingAll(false);
//   };

//   const tabs = [
//     { id: "live", label: "Open trades", count: openTrades.length },
//     { id: "closed", label: "Closed today", count: closedTrades.length },
//     { id: "signals", label: "Signals", count: signals.length },
//   ];

//   return (
//     <div className="strategy-page">
//       {/* ═══ Header ═══ */}
//       <header className="sp-header">
//         <div>
//           <h1 className="sp-title">Strategy Dashboard</h1>
//           <p className="sp-subtitle">
//             Live via WebSocket
//             <span className="sp-pulse" />
//             <span className="sp-dot-sep">·</span>
//             25 pt target
//           </p>
//         </div>

//         <div className="sp-header-actions">
//           <div
//             className="sp-toggle-wrap"
//             onClick={() => toggleAutoTrade(!autoOn)}
//           >
//             <div className={`sp-toggle ${autoOn ? "on" : "off"}`}>
//               <div className="sp-toggle-knob" />
//             </div>
//             <span className="sp-toggle-label">
//               Auto-trade {autoOn ? "on" : "off"}
//             </span>
//           </div>

//           {openTrades.length > 0 && (
//             <button
//               className="sp-btn-danger"
//               onClick={handleCloseAll}
//               disabled={closingAll}
//             >
//               {closingAll ? "Closing..." : "Close all"}
//             </button>
//           )}
//         </div>
//       </header>

//       {/* ═══ Summary cards ═══ */}
//       <div className="sp-stats">
//         <StatCard label="Open trades" value={summary.openCount || 0} />
//         <StatCard label="Closed today" value={summary.totalTrades || 0} />
//         <StatCard label="Win rate" value={`${summary.winRate || 0}%`} />
//         <StatCard
//           label="Open P&L"
//           value={`${fmtPts(summary.openPnlPoints)} pts`}
//           type={summary.openPnlPoints >= 0 ? "profit" : "loss"}
//         />
//         <StatCard
//           label="Realized"
//           value={fmtINR(summary.totalPnlAmount)}
//           type={summary.totalPnlAmount >= 0 ? "profit" : "loss"}
//         />
//         <StatCard
//           label="Net points"
//           value={`${fmtPts(summary.totalPnlPoints)} pts`}
//           type={summary.totalPnlPoints >= 0 ? "profit" : "loss"}
//         />
//       </div>

//       {/* ═══ Tabs ═══ */}
//       <nav className="sp-tabs">
//         {tabs.map((t) => (
//           <button
//             key={t.id}
//             className={`sp-tab ${tab === t.id ? "active" : ""}`}
//             onClick={() => setTab(t.id)}
//           >
//             {t.label}
//             {t.count > 0 && <span className="sp-tab-badge">{t.count}</span>}
//           </button>
//         ))}
//       </nav>

//       {/* ═══ Tab content ═══ */}
//       <section className="sp-content">
//         {tab === "live" &&
//           (openTrades.length === 0 ? (
//             <EmptyState text="No open trades. Signals will auto-enter when conditions are met." />
//           ) : (
//             openTrades.map((trade) => (
//               <TradeCard
//                 key={trade.id}
//                 trade={trade}
//                 isOpen
//                 onClose={(id, price) => closeTrade(id, price)}
//               />
//             ))
//           ))}

//         {tab === "closed" &&
//           (closedTrades.length === 0 ? (
//             <EmptyState text="No closed trades today." />
//           ) : (
//             closedTrades.map((trade) => (
//               <TradeCard key={trade.id} trade={trade} isOpen={false} />
//             ))
//           ))}

//         {tab === "signals" &&
//           (signals.length === 0 ? (
//             <EmptyState text="No signals yet. Scanning on every 5-min candle close." />
//           ) : (
//             signals.map((sig, i) => (
//               <SignalRow key={sig.id || i} signal={sig} />
//             ))
//           ))}
//       </section>
//     </div>
//   );
// }

// import { useState } from "react";
// import { useStrategy } from "../hooks/useStrategy";
// import TradeCard from "../components/TradeCard";
// import SignalRow from "../components/SignalRow";

// export default function StrategyDashboard() {
//   const {
//     openTrades,
//     closedTrades,
//     signals,
//     summary,
//     settings,
//     loading,
//     error,
//     toggleAutoTrade,
//     closeTrade,
//     closeAll,
//   } = useStrategy();

//   const [tab, setTab] = useState("live");
//   const [closingAll, setClosingAll] = useState(false);

//   if (loading) return <Loader />;
//   if (error) return <ErrorState message={error} />;

//   const autoOn = settings.auto_trade_enabled;

//   const handleCloseAll = async () => {
//     setClosingAll(true);
//     await closeAll();
//     setClosingAll(false);
//   };

//   const tabs = [
//     { id: "live", label: "Open trades", count: openTrades.length },
//     { id: "closed", label: "Closed today", count: closedTrades.length },
//     { id: "signals", label: "Signals", count: signals.length },
//   ];

//   return (
//     <div className="strategy-page">
//       {/* ═══ Header ═══ */}
//       <header className="sp-header">
//         <div>
//           <h1 className="sp-title">Strategy Dashboard</h1>
//           <p className="sp-subtitle">
//             Live via WebSocket
//             <span className="sp-pulse" />
//             <span className="sp-dot-sep">·</span>
//             25 pt target
//           </p>
//         </div>

//         <div className="sp-header-actions">
//           <div
//             className="sp-toggle-wrap"
//             onClick={() => toggleAutoTrade(!autoOn)}
//           >
//             <div className={`sp-toggle ${autoOn ? "on" : "off"}`}>
//               <div className="sp-toggle-knob" />
//             </div>
//             <span className="sp-toggle-label">
//               Auto-trade {autoOn ? "on" : "off"}
//             </span>
//           </div>

//           {openTrades.length > 0 && (
//             <button
//               className="sp-btn-danger"
//               onClick={handleCloseAll}
//               disabled={closingAll}
//             >
//               {closingAll ? "Closing..." : "Close all"}
//             </button>
//           )}
//         </div>
//       </header>

//       {/* ═══ Summary cards ═══ */}
//       <div className="sp-stats">
//         <StatCard label="Open trades" value={summary.openCount || 0} />
//         <StatCard label="Closed today" value={summary.totalTrades || 0} />
//         <StatCard label="Win rate" value={`${summary.winRate || 0}%`} />
//         <StatCard
//           label="Open P&L"
//           value={`${fmtPts(summary.openPnlPoints)} pts`}
//           type={summary.openPnlPoints >= 0 ? "profit" : "loss"}
//         />
//         <StatCard
//           label="Realized"
//           value={fmtINR(summary.totalPnlAmount)}
//           type={summary.totalPnlAmount >= 0 ? "profit" : "loss"}
//         />
//         <StatCard
//           label="Net points"
//           value={`${fmtPts(summary.totalPnlPoints)} pts`}
//           type={summary.totalPnlPoints >= 0 ? "profit" : "loss"}
//         />
//       </div>

//       {/* ═══ Tabs ═══ */}
//       <nav className="sp-tabs">
//         {tabs.map((t) => (
//           <button
//             key={t.id}
//             className={`sp-tab ${tab === t.id ? "active" : ""}`}
//             onClick={() => setTab(t.id)}
//           >
//             {t.label}
//             {t.count > 0 && <span className="sp-tab-badge">{t.count}</span>}
//           </button>
//         ))}
//       </nav>

//       {/* ═══ Tab content ═══ */}
//       <section className="sp-content">
//         {tab === "live" &&
//           (openTrades.length === 0 ? (
//             <EmptyState text="No open trades. Signals will auto-enter when conditions are met." />
//           ) : (
//             openTrades.map((trade) => (
//               <TradeCard
//                 key={trade.id}
//                 trade={trade}
//                 isOpen
//                 onClose={(id, price) => closeTrade(id, price)}
//               />
//             ))
//           ))}

//         {tab === "closed" &&
//           (closedTrades.length === 0 ? (
//             <EmptyState text="No closed trades today." />
//           ) : (
//             closedTrades.map((trade) => (
//               <TradeCard key={trade.id} trade={trade} isOpen={false} />
//             ))
//           ))}

//         {tab === "signals" &&
//           (signals.length === 0 ? (
//             <EmptyState text="No signals yet. Scanning on every 5-min candle close." />
//           ) : (
//             signals.map((sig, i) => (
//               <SignalRow key={sig.id || i} signal={sig} />
//             ))
//           ))}
//       </section>
//     </div>
//   );
// }

// ── Sub-components ───────────────────────────────────────

// function StatCard({ label, value, type }) {
//   return (
//     <div className="sp-stat">
//       <div className="sp-stat-label">{label}</div>
//       <div className={`sp-stat-value ${type || ""}`}>{value}</div>
//     </div>
//   );
// }

// function EmptyState({ text }) {
//   return <div className="sp-empty">{text}</div>;
// }

// function Loader() {
//   return (
//     <div className="sp-center">
//       <div className="sp-spinner" />
//       <p>Loading dashboard...</p>
//     </div>
//   );
// }

// function ErrorState({ message }) {
//   return (
//     <div className="sp-center sp-error">
//       <p>Failed to load dashboard</p>
//       <p className="sp-error-detail">{message}</p>
//     </div>
//   );
// }

// // ── Helpers ──────────────────────────────────────────────

// function fmtPts(n) {
//   return (n || 0).toFixed(1);
// }

// function fmtINR(n) {
//   return `₹${(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
// }

// ── Sub-components ───────────────────────────────────────

// function StatCard({ label, value, type }) {
//   return (
//     <div className="sp-stat">
//       <div className="sp-stat-label">{label}</div>
//       <div className={`sp-stat-value ${type || ""}`}>{value}</div>
//     </div>
//   );
// }

// function EmptyState({ text }) {
//   return <div className="sp-empty">{text}</div>;
// }

// function Loader() {
//   return (
//     <div className="sp-center">
//       <div className="sp-spinner" />
//       <p>Loading dashboard...</p>
//     </div>
//   );
// }

// function ErrorState({ message }) {
//   return (
//     <div className="sp-center sp-error">
//       <p>Failed to load dashboard</p>
//       <p className="sp-error-detail">{message}</p>
//     </div>
//   );
// }

// // ── Helpers ──────────────────────────────────────────────

// function fmtPts(n) {
//   return (n || 0).toFixed(1);
// }

// function fmtINR(n) {
//   return `₹${(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
// }

// import { useState } from "react";
// import { useStrategy } from "../hooks/useStrategy";
// import TradeCard from "../components/TradeCard";
// import SignalRow from "../components/SignalRow";

export default function StrategyDashboard() {
  const {
    openTrades,
    closedTrades,
    signals,
    summary,
    settings,
    loading,
    error,
    toggleAutoTrade,
    closeTrade,
    closeAll,
  } = useStrategy();

  const [tab, setTab] = useState("live");
  const [closingAll, setClosingAll] = useState(false);

  if (loading) return <Loader />;
  if (error) return <ErrorState message={error} />;

  const autoOn = settings.auto_trade_enabled;

  const handleCloseAll = async () => {
    setClosingAll(true);
    await closeAll();
    setClosingAll(false);
  };

  const tabs = [
    { id: "live", label: "Open trades", count: openTrades.length },
    { id: "closed", label: "Closed today", count: closedTrades.length },
    { id: "signals", label: "Signals", count: signals.length },
  ];

  return (
    <div className="strategy-page">
      {/* ═══ Header ═══ */}
      <header className="sp-header">
        <div>
          <h1 className="sp-title">Strategy Dashboard</h1>
          <p className="sp-subtitle">
            Live via WebSocket
            <span className="sp-pulse" />
            <span className="sp-dot-sep">·</span>
            25 pt target
          </p>
        </div>

        <div className="sp-header-actions">
          <div
            className="sp-toggle-wrap"
            onClick={() => toggleAutoTrade(!autoOn)}
          >
            <div className={`sp-toggle ${autoOn ? "on" : "off"}`}>
              <div className="sp-toggle-knob" />
            </div>
            <span className="sp-toggle-label">
              Auto-trade {autoOn ? "on" : "off"}
            </span>
          </div>

          {openTrades.length > 0 && (
            <button
              className="sp-btn-danger"
              onClick={handleCloseAll}
              disabled={closingAll}
            >
              {closingAll ? "Closing..." : "Close all"}
            </button>
          )}
        </div>
      </header>

      {/* ═══ Summary cards ═══ */}
      <div className="sp-stats">
        <StatCard label="Open trades" value={summary.openCount || 0} />
        <StatCard label="Closed today" value={summary.totalTrades || 0} />
        <StatCard label="Win rate" value={`${summary.winRate || 0}%`} />
        <StatCard
          label="Open P&L"
          value={`${fmtPts(summary.openPnlPoints)} pts`}
          type={summary.openPnlPoints >= 0 ? "profit" : "loss"}
        />
        <StatCard
          label="Realized"
          value={fmtINR(summary.totalPnlAmount)}
          type={summary.totalPnlAmount >= 0 ? "profit" : "loss"}
        />
        <StatCard
          label="Net points"
          value={`${fmtPts(summary.totalPnlPoints)} pts`}
          type={summary.totalPnlPoints >= 0 ? "profit" : "loss"}
        />
      </div>

      {/* ═══ Tabs ═══ */}
      <nav className="sp-tabs">
        {tabs.map((t) => (
          <button
            key={t.id}
            className={`sp-tab ${tab === t.id ? "active" : ""}`}
            onClick={() => setTab(t.id)}
          >
            {t.label}
            {t.count > 0 && <span className="sp-tab-badge">{t.count}</span>}
          </button>
        ))}
      </nav>

      {/* ═══ Tab content ═══ */}
      <section className="sp-content">
        {tab === "live" &&
          (openTrades.length === 0 ? (
            <EmptyState text="No open trades. Signals will auto-enter when conditions are met." />
          ) : (
            openTrades.map((trade) => (
              <TradeCard
                key={trade.id}
                trade={trade}
                isOpen
                onClose={(id, price) => closeTrade(id, price)}
              />
            ))
          ))}

        {tab === "closed" &&
          (closedTrades.length === 0 ? (
            <EmptyState text="No closed trades today." />
          ) : (
            closedTrades.map((trade) => (
              <TradeCard key={trade.id} trade={trade} isOpen={false} />
            ))
          ))}

        {tab === "signals" &&
          (signals.length === 0 ? (
            <EmptyState text="No signals yet. Scanning on every 5-min candle close." />
          ) : (
            signals.map((sig, i) => (
              <SignalRow key={sig.id || i} signal={sig} />
            ))
          ))}
      </section>
    </div>
  );
}

// ── Sub-components ───────────────────────────────────────

function StatCard({ label, value, type }) {
  return (
    <div className="sp-stat">
      <div className="sp-stat-label">{label}</div>
      <div className={`sp-stat-value ${type || ""}`}>{value}</div>
    </div>
  );
}

function EmptyState({ text }) {
  return <div className="sp-empty">{text}</div>;
}

function Loader() {
  return (
    <div className="sp-center">
      <div className="sp-spinner" />
      <p>Loading dashboard...</p>
    </div>
  );
}

function ErrorState({ message }) {
  return (
    <div className="sp-center sp-error">
      <p>Failed to load dashboard</p>
      <p className="sp-error-detail">{message}</p>
    </div>
  );
}

// ── Helpers ──────────────────────────────────────────────

function fmtPts(n) {
  return (n || 0).toFixed(1);
}

function fmtINR(n) {
  return `₹${(n || 0).toLocaleString("en-IN", { maximumFractionDigits: 0 })}`;
}
